<template>
  <div :class="['lr-modal reasons-modal', {'hide': !queueError.reasonsModal}]">
    <div class="lr-box">
      <div class="lr-top">
        <table class="reason-table" cellpadding="5" cellspacing="0">
          <thead>
            <th class="driver">Driver</th>
            <th class="reason">Reason</th>
          </thead>
          <tbody>
            <tr v-for="qe in queueError.list">
              <td class="driver"><a :href="'/#/provider/' + qe.id" target="_blank">{{ qe.name }}</a></td>
              <td class="reason">{{ reasonLabel(qe.reason) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <a class="button cta small right lr-close" @click="closeReasons">Close</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reason-modal',
  computed: {
  },
  data () {
    return {
    }
  },
  computed: {
    queueError () { return this.$store.state.global.reasons }
  },
  methods: {
    reasonLabel (x) {
      switch (x) {
        case 'serviceType': return 'Driver cannot accept this service type'
        case 'seats': return 'Driver vehcile does not have enough seat capacity'
        case 'adaWC': return 'Requires ADA wheelchair'
        case 'adaSD': return 'Requires ADA service dog'
        case 'fullTNC': return 'Do not give full TNC runs to TCP drivers'
        case 'availability': return 'Driver availability does not match'
        case 'distance': return 'Driver distance to first pickup location'
        default: return x
      }
    },
    closeReasons () {
      // this.queueError.reasonsModal = false
      this.$store.commit('global/setReasonsData', {reasonsModal: false})
      this.$forceUpdate()
    }
  },
  mounted () {
  },
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  // padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  width: 600px;
  max-width: 600px;
  max-height: calc(100vh - 40px);
  overflow: hidden;
}
.reasons-modal {
  &.hide{
    display: none;
  }
}
.lr-top{
  padding: 20px;
  max-height: calc(100vh - 120px);
  overflow:auto;
  border-bottom: 1px solid #eee;
  background: #f3f3f3;
}
.reason-table{
  width: 100%;
  max-width: 600px;
  border: 1px solid #ccc;
  background: #fff;
  th{
    background: #fafafa;
    padding: 4px;
    border-bottom: 1px solid #ccc;;
  }
  .driver{
    text-align: left;
  }
  .reason {
    text-align: right;
  }
  tr{
    td{
      border-bottom: 1px solid #ccc;
      font-size: 14px;
    }
    .reason {
      font-size: 13px;
      color: #444;
      font-family: monospace;
    }
  }
}
.lr-close{
  margin: 10px auto;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/App/ReasonModal.vue